<template>
  <el-dialog custom-class="password-change-container dialog-size-middle"
             title="パスワード変更"
             :top="0"
             :modal="false"
             append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="password-change-container-inner">
        <form-container ref="formContainer">
          <form-item-container label="現在のパスワード">
            <field-container>
              <field-input name="old_password" type="password" v-model="oldPassword" validate="required" validateLabel="現在のパスワード"></field-input>
            </field-container>
          </form-item-container>

          <form-item-container label="新しいパスワード">
            <field-container>
              <field-input name="new_password" type="password" v-model="newPassword" :validate="{required: true, alpha_num_symbol: true, is_not: oldPassword, min: 8}" validateLabel="新しいパスワード"></field-input>
            </field-container>
          </form-item-container>

          <form-item-container>
            <span slot="form-item-label">新しいパスワード<br>（確認）</span>
            <field-container>
              <field-input name="confirm_password" type="password" v-model="confirmPassword" :validate="{required: true, confirmed: newPassword}" validateLabel="新しいパスワード（確認）"></field-input>
            </field-container>
          </form-item-container>
        </form-container>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickOk">OK</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
import WebApiClient from '../../../api/web'
import MessageBox from '../../../utils/message-box'
import { Code } from '../../../api/base'

export default {
  name: 'PasswordChangeDialogCmp',
  components: {},
  data () {
    return {
      visible: true,
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    onClickOk () {
      this.$refs.formContainer.$validator.validateAll().then((result) => {
        if (result) {
          WebApiClient.putAccountPassword(this, window.USER_ID, {
            newPassword: this.newPassword,
            oldPassword: this.oldPassword
          }).then(response => {
            if (response.data.code === Code.SUCCESS) {
              MessageBox.alert(this, 'パスワードを変更しました。<br>再度ログインし直してください。', {
                showClose: false,
                dangerouslyUseHTMLString: true,
                callback: () => {
                  window.location.href = '/logout/'
                }
              })
            }
          })
        }
      })
    }
  }
}

</script>

<style type="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/dialogs/password-change.vue